import React from "react";
import styled from "styled-components";
import { Button } from "../../components/AuthComponents";
import { breakpoints } from "../../Media";
import { withRouter, Link } from "react-router-dom";

function LostPage() {
  return (
    <MainDiv>
      <Title>Oooops! You seem to be lost.</Title>
      <Link to="/">
        <NewButton>Go Back Home</NewButton>
      </Link>
    </MainDiv>
  );
}

export default withRouter(LostPage);

const MainDiv = styled.div`
  height: 55vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  margin: 0 2em 2em 2em;
`;

const Title = styled.h1`
  font-size: 3em;
  font-weight: 900;
  text-align: center;
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 2em;
    line-height: 1;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 2.4em;
    line-height: 1.1;
  }
`;

const NewButton = styled(Button)`
  width: 10em;
  border-radius: 4px;
`;
